module.exports = __webpack_public_path__ + "img/img32.3837f5b8.svg";